export default function SectionTitle({ eyebrow, title, sub, center, action }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 20,
      flexWrap: 'wrap', marginBottom: 28, textAlign: center ? 'center' : 'left',
      flexDirection: center ? 'column' : 'row',
    }}>
      <div className="col gap-2" style={{ alignItems: center ? 'center' : 'flex-start' }}>
        {eyebrow && (
          <div className="eyebrow" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 18, height: 2, background: 'var(--accent)', display: 'inline-block' }} />
            {eyebrow}
          </div>
        )}
        <h2 className="display" style={{ margin: 0, fontSize: 'clamp(28px, 4vw, 42px)' }}>{title}</h2>
        {sub && <p style={{ margin: 0, color: 'var(--fg-muted)', maxWidth: 560, fontSize: 15, lineHeight: 1.5 }}>{sub}</p>}
      </div>
      {action}
    </div>
  );
}
